import script from "./SOPMainSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SOPMainSideBar.vue?vue&type=script&setup=true&lang=js"

import "./SOPMainSideBar.vue?vue&type=style&index=0&id=1206559a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1206559a"]])

export default __exports__